// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5169":"7f8d0b2b","5654":"fcef6952","8366":"c2589261"}[chunkId] + ".chunk.css";
};